// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ2_SEARCH_BUTTON = "H\u013eadaj";
export const CONFIRM = "Potvr\u010f";
